export default "__VITE_ASSET__DnzcjtPG__"